import { useEffect, useState } from 'react';
import { useM2MApiContext } from '../../../api/m2mApi';
import { TpOrganizationInfo, TpPluginInfo } from '../../../api/models/admin';
import { useUser } from '../../../app/hooks';
import { OrganizationsPluginModal } from '../actions/m2mOrganizationPluginModal';
import OrganizationDetails from './OrganizationDetails';
import ManagePluginsButton from './ManagePluginsButton';
import IngestDataButton from './IngestDataButton';
import CleanupButton from './CleanupButton';
import SyncCatalogButton from './SyncCatalogButton';
import ExportDataButton from './ExportDataButton';
import styles from '../AdminPortal.module.scss';

export default function OrganizationOverview() {
  const adminApi = useM2MApiContext().organizationAdmin;
  const { user } = useUser();
  const organizationId = user.organizations.find((org) => org.isActive)?.organizationId;
  const [organization, setOrganization] = useState<TpOrganizationInfo | null>(null);
  const [plugins, setPlugins] = useState<TpPluginInfo[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');

  const toggleLoading = (enable: boolean, message: string = '') => {
    setIsLoading(enable);
    setLoadingMessage(message);
  };

  const updateOrganization = () => {
    if (!organizationId) {
      return;
    }
    adminApi.fetchOrganization(organizationId).then(setOrganization);
  };

  useEffect(() => {
    if (!organizationId) {
      return;
    }

    adminApi
      .fetchOrganization(organizationId)
      .then((fetchedOrganization) => {
        setOrganization(fetchedOrganization);
        return adminApi.listPlugins();
      })
      .then((fetchedPlugins) => {
        setPlugins(fetchedPlugins);
      });
  }, [organizationId]);

  if (organization === null) {
    return (
      <>
        <OrganizationsPluginModal />
        {isLoading && (
          <div className={styles.loadingBox}>
            <span className={styles.loadingMessage}>{loadingMessage}</span>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <OrganizationsPluginModal />
      {isLoading && (
        <div className={styles.loadingBox}>
          <span className={styles.loadingMessage}>{loadingMessage}</span>
        </div>
      )}
      <div className={styles.organizationOverview}>
        <div className={styles.organizationActionBlock}>
          <ManagePluginsButton
            organization={organization}
            plugins={plugins}
            adminApi={adminApi}
            toggleLoading={toggleLoading}
            updateOrganizations={updateOrganization}
          />
          <IngestDataButton organization={organization} adminApi={adminApi} />
          <ExportDataButton organization={organization} adminApi={adminApi} />
          <CleanupButton organization={organization} adminApi={adminApi} />
          <SyncCatalogButton organization={organization} adminApi={adminApi} />
        </div>
        <OrganizationDetails organization={organization} plugins={plugins} listUsers={true} />
      </div>
    </>
  );
}
